/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { MemberTierDropdownResponseDto } from '../model/memberTierDropdownResponseDto';
import { MemberTierPaginationResponseDto } from '../model/memberTierPaginationResponseDto';
import { MemberTierRequestDto } from '../model/memberTierRequestDto';
import { MemberTierResponseDto } from '../model/memberTierResponseDto';
import { MemberTierUpdateSequenceRequestDto } from '../model/memberTierUpdateSequenceRequestDto';
import { ValidationError } from '../model/validationError';

export enum memberTiersDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum memberTiersGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum memberTiersIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class MemberTiersService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public memberTiersDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<Array<MemberTierDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/member-tiers/dropdown`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<MemberTierPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/member-tiers`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/member-tiers/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersIdGet$(id: string, language?: string): Observable<MemberTierResponseDto> {
    return this.api.get(`${apiBaseUrl()}/member-tiers/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersIdPut$(id: string, body: MemberTierRequestDto): Observable<MemberTierResponseDto> {
    return this.api.put(`${apiBaseUrl()}/member-tiers/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/member-tiers/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersPost$(body: MemberTierRequestDto): Observable<MemberTierResponseDto> {
    return this.api.post(`${apiBaseUrl()}/member-tiers`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public memberTiersUpdateSequencePut$(body: Array<MemberTierUpdateSequenceRequestDto>): Observable<string> {
    return this.api.put(`${apiBaseUrl()}/member-tiers/update-sequence`, body, undefined);
  }
}
